import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/servicios/:url',
    name: 'Servicio',
    component: () => import('../views/Servicio.vue')
  },
  {
    path: '/servicios/fibra-oscura',
    name: 'Fibra Oscura',
    component: () => import('../views/FibraOscura.vue')
  },
  {
    path: '/contacto',
    name: 'Contacto',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/duenos-y-arrendadores',
    name: 'Duenos y Arrendadores',
    component: () => import('../views/DuenosArrendadores.vue')
  },
  {
    path: '/renta-servicios',
    name: 'Renta Servicio',
    component: () => import('../views/RentaServicios.vue')
  },
  {
    path: '/terminos-y-condiciones',
    name: 'Terminos y Condiciones',
    component: () => import('../views/TerminosyCondiciones.vue')
  },
  {
    path: '/productos',
    name: 'Productos',
    component: () => import('../views/Producto.vue')
  },
  {
    path: '/productos/metro',
    name: 'Productos',
    component: () => import('../views/Metro.vue')
  },
  {
    path: '/productos/next',
    name: 'Productos',
    component: () => import('../views/Next.vue')
  },
  {
    path: '/productos/link',
    name: 'Productos',
    component: () => import('../views/Link.vue')
  },
  {
    path: '/NuestraDiferencia',
    name: 'Por que nosotros',
    component: () => import('../views/PorQue.vue')
  },
  {
    path: '/blog',
    name: 'Blog',
    component: () => import('../views/Blog.vue')
  },
  {
    path: '/aviso-de-privacidad',
    name: 'AvisoDePrivacidad',
    component: () => import('../views/AvisoDePrivacidad.vue')
  },
  {
    path: '/academy',
    name: 'Academy',
    component: () => import('../views/Academy.vue')
  },
  {
    path: '/blog/:url',
    name: 'Post',
    component: () => import('../views/Post.vue')
  },
  {
    path: '/acerca-de',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
